window.addEventListener('DOMContentLoaded', () => {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();

    const phoneNumberElements = document.querySelectorAll('[data-contact-phone]');
    const emailElements = document.querySelectorAll('[data-contact-email]');

    if ((day >= 1 && day <= 5 && hour >= 9 && hour < 18) || (day === 6 && hour >= 9 && hour < 17)) {
        phoneNumberElements.forEach((element) => {
            element.style.display = 'block';
        });
        emailElements.forEach((element) => {
            element.style.display = 'none';
        });
    } else {
        phoneNumberElements.forEach((element) => {
            element.style.display = 'none';
        });
        emailElements.forEach((element) => {
            element.style.display = 'block';
        });
    }
});